import script from "./CServices.vue?vue&type=script&setup=true&lang=ts"
export * from "./CServices.vue?vue&type=script&setup=true&lang=ts"

import "./CServices.vue?vue&type=style&index=0&id=49cb233e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49cb233e"]])

export default __exports__